import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/BillOfLading/components/SectionLegal/SectionLegal.module.scss';

const cn = classNames.bind(styles);

const SectionLegal = (): ReactElement => {
  return (
    <section className={cn('legal')}>
      <div className={cn('container')}>
        <h2 className={cn('legal__heading')}>
          What are the Legal Implications and Importance of a Bill of Lading (BoL)?
        </h2>

        <div className={cn('legal__paragraphs')}>
          <div className={cn('legal__paragraphs-column')}>
            <p className={cn('legal__paragraph')}>
              The Bill of Lading carries significant legal implications that freight forwarders and NVOCC
              managers must thoroughly understand. These implications affect not only the logistics process
              but also the legal responsibilities of the parties involved.
            </p>
            <p className={cn('legal__paragraph')}>
              <span className={cn('legal__text-bold')}>Contract of Carriage and Title Transfer:</span> Bill of Lading serve as evidence of the contract of
              carriage between the shipper and the carrier. It outlines the terms under which the goods are
              transported, including responsibilities for loss or damage, and establishes the conditions under
              which claims can be made. A Bill of Lading is issued by a transport company, such as a
              shipping line, trucking company, railroad, or air freight company, to the shipper of goods.
              Additionally, the BoL can be used as a document of title, allowing the transfer of ownership of
              the goods while they are in transit. This feature is particularly important in international trade,
              where goods may be bought and sold multiple times before reaching their final destination.
            </p>
          </div>
          <div className={cn('legal__paragraphs-column')}>
            <p className={cn('legal__paragraph')}>
              <span className={cn('legal__text-bold')}>Legal Framework and Compliance:</span> A BoL is governed by a range of international conventions,
              such as the Hague-Visby Rules, the Hamburg Rules, and the Rotterdam Rules, which set out
              the rights and obligations of carriers and shippers. These conventions provide a standardized
              legal framework that facilitates international trade by ensuring that there are clear rules
              governing the transport of goods. In addition to these international laws, Bills of Lading are
              also subject to national regulations, which can vary significantly from country to country.
              Compliance with these regulations is crucial to avoid legal disputes, fines, and delays.
            </p>
            <p className={cn('legal__paragraph')}>
              <span className={cn('legal__text-bold')}>Consequences of Errors:</span> Non-compliance errors in a Bill of Lading, such as incorrect
              descriptions of goods, missing information, or misrepresentations, can lead to significant
              issues, including delays in shipment, additional costs, and legal disputes. For example, if the
              goods are misdescribed on the BoL, customs authorities may detain the shipment, resulting in
              delays and additional inspection fees. Moreover, non-compliance with legal requirements can
              result in fines, penalties, and potential litigation. Ensuring accuracy and compliance in the
              preparation of Bills of Lading is therefore essential to avoid these risks and maintain smooth
              logistics operations.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SectionLegal;